import { makeRedirects } from "@/helpers/routes";

import { routes as app } from "@/router/routes/app";
import { routes as auth } from "@/router/routes/auth";
import { routes as settings } from "@/router/routes/settings";

export const routes = [...app, ...auth, ...settings, ...makeRedirects()];
